import { ILoyaltyAvatarListItem } from "types/Loyalty";

import "./styles.sass";
import LoyaltyAvatarListItem from "components/atoms/LoyaltyAvatarListItem";

type LoyaltyAvatarListProps = {
  list: ILoyaltyAvatarListItem[];
  selected: string | null;
  handleSelect: (avatar: string) => void;
};

const LoyaltyAvatarList = (props: LoyaltyAvatarListProps) => {
  const { list, selected, handleSelect } = props;

  return (
    <div className="LoyaltyAvatarList">
      {list?.map((item: ILoyaltyAvatarListItem) => (
        <LoyaltyAvatarListItem
          key={item.id}
          id={item.id}
          avatar={item.avatar}
          locked={item.locked}
          selected={selected === item.avatar}
          onClick={handleSelect}
        />
      ))}
    </div>
  );
};

export default LoyaltyAvatarList;
